import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class RequestPurchaseReturn extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Request Purchase Return
					</div>
					<div>
						<DownloadFile title="Download Request Purchase Return Template" url="ingest/inventory/transfer/item/template"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/inventory/purchase-returns/request"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/PurchaseReturn/Components/RequestPurchaseReturn.js